import { render, staticRenderFns } from "./SalesCard.vue?vue&type=template&id=9c412c34&scoped=true"
import script from "./SalesCard.vue?vue&type=script&lang=js"
export * from "./SalesCard.vue?vue&type=script&lang=js"
import style0 from "./SalesCard.vue?vue&type=style&index=0&id=9c412c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c412c34",
  null
  
)

export default component.exports